import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Sparkles, KeyRound, Save, ArrowLeft, AlertCircle } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function AdminResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!token) toast.error('Token mancante nel link'); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) { toast.error('Le password non coincidono'); return; }
    if (pwd.length < 8) { toast.error('Minimo 8 caratteri'); return; }
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: pwd });
      toast.success('Password aggiornata. Effettua il login.');
      setTimeout(() => navigate('/admin/login'), 800);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Token non valido o scaduto');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[color:var(--bg)] hero-overlay relative">
      <div className="w-full max-w-md rounded-2xl border border-[color:var(--border-c)] bg-[color:var(--surface)] p-7 relative z-10 shadow-[0_30px_80px_rgba(0,0,0,0.7)]">
        <div className="flex items-center gap-2 mb-2"><Sparkles className="w-4 h-4 text-[color:var(--gold)]"/><span className="text-xs uppercase tracking-[0.3em] text-[color:var(--gold)]">Nuova password</span></div>
        <h1 className="font-heading text-3xl mb-1">Imposta la password</h1>
        <p className="text-sm text-[color:var(--text-muted)] mb-6">Scegli una nuova password (min. 8 caratteri).</p>
        {!token ? (
          <div className="flex items-center gap-2 text-red-300 text-sm bg-red-900/20 border border-red-900/40 rounded-lg p-3"><AlertCircle className="w-4 h-4"/>Token mancante. Richiedi un nuovo link.</div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
            <div>
              <Label className="text-xs uppercase tracking-wider text-[color:var(--text-subtle)]">Nuova password</Label>
              <Input data-testid="reset-password-new" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} required minLength={8} className="mt-1 bg-[color:var(--surface-2)] border-[color:var(--border-c)]"/>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-[color:var(--text-subtle)]">Conferma password</Label>
              <Input data-testid="reset-password-confirm" type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} required minLength={8} className="mt-1 bg-[color:var(--surface-2)] border-[color:var(--border-c)]"/>
            </div>
            <Button data-testid="reset-password-submit" type="submit" disabled={busy} className="w-full bg-[color:var(--gold-strong)] hover:bg-[#C6A21A] text-black font-semibold"><Save className="w-4 h-4 mr-2"/>{busy ? 'Salvataggio…' : 'Imposta nuova password'}</Button>
          </form>
        )}
        <div className="mt-6 pt-4 border-t border-[color:var(--border-c)] text-center">
          <Link to="/admin/login" className="text-xs text-[color:var(--text-subtle)] hover:text-[color:var(--gold)] inline-flex items-center gap-1"><ArrowLeft className="w-3 h-3"/>Login</Link>
        </div>
      </div>
    </div>
  );
}
